import { Trans, useTranslation } from "react-i18next";

import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";
import { useDeleteMission } from "src/core/hooks/folder/useDeleteMission";
import { IMission } from "src/core/hooks/folder/useFolderMissions";

type DeleteMissionModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  mission: IMission | null;
  setMissionToEdit: (mission: IMission | null) => void;
};

export const DeleteMissionModal = ({
  open,
  setOpen,
  mission,
  setMissionToEdit,
}: DeleteMissionModalProps) => {
  const { t } = useTranslation();

  const { handleDelete, loading } = useDeleteMission(setOpen, mission, setMissionToEdit);

  if (!mission) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        hideCloseButton
        onInteractOutside={(e) => e.preventDefault()}
        className="w-[440px]"
      >
        <DialogHeader>
          <DialogTitle>{t("deleteMission.modal.title")}</DialogTitle>
          <DialogDescription className="sr-only">
            {t("deleteMission.modal.description")}
          </DialogDescription>
        </DialogHeader>

        <DialogDescription style={{ whiteSpace: "pre-line" }}>
          <Trans
            i18nKey="deleteMission.modal.description"
            values={{ missionType: mission.missionType }}
            components={{ strong: <strong /> }}
          />
        </DialogDescription>

        <DialogFooter>
          <Button variant="default" className="ml-[20px]" onClick={handleDelete} loading={loading}>
            {t("deleteMission.modal.submit")}
          </Button>
          <Button
            variant="link"
            onClick={(event) => {
              event.preventDefault();
              setOpen(false);
              setMissionToEdit(null);
            }}
            disabled={loading}
          >
            {t("global.form.cancel")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
